export default "__VITE_ASSET__BpIkeE2v__"